import { fetchUserInboxNotifications } from '../slices/notificationSlice/userInboxNotificationSlice';

// Refreshes the inbox notification summary right after any workflow action that likely changed
// what's pending — a submit, approval, verification, rejection, save, or close on one of the
// ~30+ purchase/HR/accounts slices — instead of waiting for the 5-minute poll in
// TopNavbarLayout.jsx or a manual refresh click.
//
// Matched by convention, not an explicit per-page list: this codebase's async-thunk names
// consistently start with the verb describing what they do (submitXxx, approveXxx, saveXxx,
// verifyXxx, rejectXxx, closeXxx — see e.g. transferRecieptMultiSlice's `submitMultiVendorReciept`,
// newStockIssueSlice's `saveIssue`). Matched against ONLY the thunk-name segment of the action
// type (`sliceName/thunkName/fulfilled`), not the whole string, so a slice name that happens to
// contain one of these words (e.g. the `rejectionAlerts` slice's own `fetchRejectionAlerts`
// thunk) doesn't false-positive — that segment starts with "fetch", not "reject".
const TRIGGER_VERBS = /^(submit|approve|save|verify|reject|close)/i;
const DEBOUNCE_MS = 800;

let debounceTimer = null;

const inboxRefreshMiddleware = (store) => (next) => (action) => {
    const result = next(action);

    if (typeof action.type === 'string' && action.type.endsWith('/fulfilled')) {
        const segments = action.type.split('/');
        const sliceName = segments[0];
        const thunkName = segments[segments.length - 2] || '';

        // Never refresh in response to the inbox slice's own fetch completing — avoids a loop.
        if (sliceName !== 'inboxnotifications' && TRIGGER_VERBS.test(thunkName)) {
            const userData = store.getState().auth?.userData;
            const roleId = userData?.roleId || userData?.RID;
            const userId = userData?.UID || userData?.uid;

            if (roleId && userId) {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => {
                    store.dispatch(fetchUserInboxNotifications({ userId, roleId }));
                }, DEBOUNCE_MS);
            }
        }
    }

    return result;
};

export default inboxRefreshMiddleware;
